import { ColumnViewModel } from '../../shared/column-types';

export const ngenes_diseaseID_SUMMARY: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'geneProteinStrIDs',
    'geneDescription',
    'geneProteinClassNames',
    'geneDSI',
    'geneDPI',
    'genepLI',
  ],
  defaultVisible: [
    'geneSymbol',
    'geneProteinStrIDs',
    'geneDescription',
    'geneProteinClassNames',
    'geneDSI',
    'geneDPI',
    'genepLI',
  ],
};